import { render, staticRenderFns } from "./mobileHelp.vue?vue&type=template&id=71886f6a&scoped=true"
import script from "./mobileHelp.vue?vue&type=script&lang=js"
export * from "./mobileHelp.vue?vue&type=script&lang=js"
import style0 from "./mobileHelp.vue?vue&type=style&index=0&id=71886f6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71886f6a",
  null
  
)

export default component.exports